// subscriptionRevenueReducer
export const annualAverageFeeMonths = {
  0: 49,
  1: 49,
  2: 49,
  3: 49,
  4: 49,
  5: 49,
  6: 49,
  7: 49,
  8: 49,
  9: 49,
  10: 49,
  11: 49,
  12: 49,
  13: 49,
  14: 49,
  15: 49,
  16: 49,
  17: 49,
  18: 49,
  19: 49,
  20: 49,
  21: 49,
  22: 49,
  23: 49,
  24: 49,
  25: 49,
  26: 49,
  27: 49,
  28: 49,
  29: 49,
  30: 49,
  31: 49,
  32: 49,
  33: 49,
  34: 49,
  35: 49,
  36: 49,
};

export const subscriptionRevenueMonths = {
  0: 0,
  1: 0,
  2: 0,
  3: 0,
  4: 0,
  5: 0,
  6: 0,
  7: 0,
  8: 0,
  9: 0,
  10: 0,
  11: 0,
  12: 0,
  13: 0,
  14: 0,
  15: 0,
  16: 0,
  17: 0,
  18: 0,
  19: 0,
  20: 0,
  21: 0,
  22: 0,
  23: 0,
  24: 0,
  25: 0,
  26: 0,
  27: 0,
  28: 0,
  29: 0,
  30: 0,
  31: 0,
  32: 0,
  33: 0,
  34: 0,
  35: 0,
  36: 0,
};

export const numberOfNewSubscribersMonths = {
  0: 5670,
  1: 5670,
  2: 12389,
  3: 18484,
  4: 24456,
  5: 31054,
  6: 31054,
  7: 31054,
  8: 31054,
  9: 31054,
  10: 31054,
  11: 31054,
  12: 31054,
  13: 31054,
  14: 31054,
  15: 31054,
  16: 31054,
  17: 31054,
  18: 31054,
  19: 31054,
  20: 31054,
  21: 31054,
  22: 31054,
  23: 31054,
  24: 31054,
  25: 31054,
  26: 31054,
  27: 31054,
  28: 31054,
  29: 31054,
  30: 31054,
  31: 31054,
  32: 31054,
  33: 31054,
  34: 31054,
  35: 31054,
  36: 31054,
};

// subscriptionCommissionsReducer

export const appStoreSalesMonths = {
  0: "",
  1: "",
  2: "",
  3: "",
  4: "",
  5: "",
  6: "",
  7: "",
  8: "",
  9: "",
  10: "",
  11: "",
  12: "",
  13: "",
  14: "",
  15: "",
  16: "",
  17: "",
  18: "",
  19: "",
  20: "",
  21: "",
  22: "",
  23: "",
  24: "",
  25: "",
  26: "",
  27: "",
  28: "",
  29: "",
  30: "",
  31: "",
  32: "",
  33: "",
  34: "",
  35: "",
  36: "",
};

export const appleAppStoreMonth = {
  0: 60,
  1: 60,
  2: 60,
  3: 60,
  4: 60,
  5: 60,
  6: 60,
  7: 60,
  8: 60,
  9: 60,
  10: 60,
  11: 60,
  12: 60,
  13: 60,
  14: 60,
  15: 60,
  16: 60,
  17: 60,
  18: 60,
  19: 60,
  20: 60,
  21: 60,
  22: 60,
  23: 60,
  24: 60,
  25: 60,
  26: 60,
  27: 60,
  28: 60,
  29: 60,
  30: 60,
  31: 60,
  32: 60,
  33: 60,
  34: 60,
  35: 60,
  36: 60,
};

export const googlePlayAppStoreMonth = {
  0: 30,
  1: 30,
  2: 30,
  3: 30,
  4: 30,
  5: 30,
  6: 30,
  7: 30,
  8: 30,
  9: 30,
  10: 30,
  11: 30,
  12: 30,
  13: 30,
  14: 30,
  15: 30,
  16: 30,
  17: 30,
  18: 30,
  19: 30,
  20: 30,
  21: 30,
  22: 30,
  23: 30,
  24: 30,
  25: 30,
  26: 30,
  27: 30,
  28: 30,
  29: 30,
  30: 30,
  31: 30,
  32: 30,
  33: 30,
  34: 30,
  35: 30,
  36: 30,
};

export const websiteStoreMonth = {
  0: 10,
  1: 10,
  2: 10,
  3: 10,
  4: 10,
  5: 10,
  6: 10,
  7: 10,
  8: 10,
  9: 10,
  10: 10,
  11: 10,
  12: 10,
  13: 10,
  14: 10,
  15: 10,
  16: 10,
  17: 10,
  18: 10,
  19: 10,
  20: 10,
  21: 10,
  22: 10,
  23: 10,
  24: 10,
  25: 10,
  26: 10,
  27: 10,
  28: 10,
  29: 10,
  30: 10,
  31: 10,
  32: 10,
  33: 10,
  34: 10,
  35: 10,
  36: 10,
};

export const appStoresTotalMonth = {
  0: 100,
  1: 100,
  2: 100,
  3: 100,
  4: 100,
  5: 100,
  6: 100,
  7: 100,
  8: 100,
  9: 100,
  10: 100,
  11: 100,
  12: 100,
  13: 100,
  14: 100,
  15: 100,
  16: 100,
  17: 100,
  18: 100,
  19: 100,
  20: 100,
  21: 100,
  22: 100,
  23: 100,
  24: 100,
  25: 100,
  26: 100,
  27: 100,
  28: 100,
  29: 100,
  30: 100,
  31: 100,
  32: 100,
  33: 100,
  34: 100,
  35: 100,
  36: 100,
};

export const googlePlayAppStoreCommissionMonth = {
  0: 15,
  1: 15,
  2: 15,
  3: 15,
  4: 15,
  5: 15,
  6: 15,
  7: 15,
  8: 15,
  9: 15,
  10: 15,
  11: 15,
  12: 15,
  13: 15,
  14: 15,
  15: 15,
  16: 15,
  17: 15,
  18: 15,
  19: 15,
  20: 15,
  21: 15,
  22: 15,
  23: 15,
  24: 15,
  25: 15,
  26: 15,
  27: 15,
  28: 15,
  29: 15,
  30: 15,
  31: 15,
  32: 15,
  33: 15,
  34: 15,
  35: 15,
  36: 15,
};

export const websiteStoreCommissionMonths = {
  0: 0,
  1: 0,
  2: 0,
  3: 0,
  4: 0,
  5: 0,
  6: 0,
  7: 0,
  8: 0,
  9: 0,
  10: 0,
  11: 0,
  12: 0,
  13: 0,
  14: 0,
  15: 0,
  16: 0,
  17: 0,
  18: 0,
  19: 0,
  20: 0,
  21: 0,
  22: 0,
  23: 0,
  24: 0,
  25: 0,
  26: 0,
  27: 0,
  28: 0,
  29: 0,
  30: 0,
  31: 0,
  32: 0,
  33: 0,
  34: 0,
  35: 0,
  36: 0,
};

// otherRevenueReducer
export const otherRevenueMonths = {
  0: 5000,
  1: 5000,
  2: 10000,
  3: 15000,
  4: 20000,
  5: 25000,
  6: 25000,
  7: 25000,
  8: 25000,
  9: 25000,
  10: 25000,
  11: 25000,
  12: 25000,
  13: 25000,
  14: 25000,
  15: 25000,
  16: 25000,
  17: 25000,
  18: 25000,
  19: 25000,
  20: 25000,
  21: 25000,
  22: 25000,
  23: 25000,
  24: 25000,
  25: 25000,
  26: 25000,
  27: 25000,
  28: 25000,
  29: 25000,
  30: 25000,
  31: 25000,
  32: 25000,
  33: 25000,
  34: 25000,
  35: 25000,
  36: 25000,
};

// unitSalesReducer
export const unitSalesMonths = {
  0: 5000,
  1: 5000,
  2: 10000,
  3: 15000,
  4: 20000,
  5: 25000,
  6: 25000,
  7: 25000,
  8: 25000,
  9: 25000,
  10: 25000,
  11: 25000,
  12: 25000,
  13: 25000,
  14: 25000,
  15: 25000,
  16: 25000,
  17: 25000,
  18: 25000,
  19: 25000,
  20: 25000,
  21: 25000,
  22: 25000,
  23: 25000,
  24: 25000,
  25: 25000,
  26: 25000,
  27: 25000,
  28: 25000,
  29: 25000,
  30: 25000,
  31: 25000,
  32: 25000,
  33: 25000,
  34: 25000,
  35: 25000,
  36: 25000,
};

export const defaultZeroMonths = {
  0: 0,
  1: 0,
  2: 0,
  3: 0,
  4: 0,
  5: 0,
  6: 0,
  7: 0,
  8: 0,
  9: 0,
  10: 0,
  11: 0,
  12: 0,
  13: 0,
  14: 0,
  15: 0,
  16: 0,
  17: 0,
  18: 0,
  19: 0,
  20: 0,
  21: 0,
  22: 0,
  23: 0,
  24: 0,
  25: 0,
  26: 0,
  27: 0,
  28: 0,
  29: 0,
  30: 0,
  31: 0,
  32: 0,
  33: 0,
  34: 0,
  35: 0,
  36: 0,
};
